function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 6a1 1 0 0 0-1 1 1 1 0 0 0 0 .004v15.992A1 1 0 0 0 3 23a1 1 0 0 0 1 1 1 1 0 0 0 .592-.195h.002a1 1 0 0 0 .027-.022L15 16.236v6.76A1 1 0 0 0 15 23a1 1 0 0 0 1 1 1 1 0 0 0 .592-.195h.002a1 1 0 0 0 .027-.022l10.92-7.941A1 1 0 0 0 28 15a1 1 0 0 0-.443-.83L16.594 6.195A1 1 0 0 0 16 6a1 1 0 0 0-1 1 1 1 0 0 0 0 .004v6.762L4.594 6.196A1 1 0 0 0 4 6z",
    style: {
      fill: "#444b54",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationSkip);
export default __webpack_public_path__ + "static/media/operationSkip.9b326afc0127d08cf7db8ef56b0b81f1.svg";
export { ForwardRef as ReactComponent };